import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import { Row } from "react-bootstrap";
import SignUp from "./SignUp/SignUp";
import SignIn from "./SignIn/SignIn";
import Log from "./image/Iog.svg";
import Register from "./image/Register.svg";
import logo2 from "../image/logo2.png";
import "./index.css";
import ForgetPwd from "./ForgetPwd/ForgetPwd";
import Navbar from "../Member/Navbar/Navbar";

const Index = (props) => {
  // const container2 = ;

  const Sign_up_btn = () => {
    document.querySelector("#container2").classList.add("sign-up-mode");
  };

  const Sign_in_btn = () => {
    document.querySelector("#container2").classList.remove("sign-up-mode");
  };

  const [show, setShow] = useState(false);

  const Toggle = () => {
    setShow(false);
  };

  return (
    <>
      <Navbar />
      <ForgetPwd Show={show} Toggle={Toggle} />
      <div id="container2" className="container2">
        <div className="forms-container2">
          <div className="signin-signup">
            <form action="#" className="sign-in-form login">
              <img src={logo2} alt="Doclic.ma" width="115px" />
              <h3>J'ai déja un compte sur Doclic.</h3>
              <SignIn />
              <Link onClick={() => setShow(true)}>Mot de passe Oublie?</Link>
              <p>
                Nouveau Sur Doclic?{" "}
                <Link
                  onClick={() => {
                    Sign_up_btn();
                  }}
                >
                  S'inscrire
                </Link>
              </p>
            </form>

            <SignUp />
          </div>
        </div>

        <div className="panels-container2">
          <div className="panel left-panel">
            <div className="content">
              <h3>Nouveau Sur Doclic ? </h3>
              <h4>Inscrivez vous en 3 actions :</h4>
              <ol className="pl-4">
                <li>Remplir le formulaire</li>
                <li>Accepter les conditions</li>
                <li>Validez votre compte</li>
              </ol>
              <button
                className="btn2 home transparent"
                id="sign-up-btn"
                onClick={() => {
                  Sign_up_btn();
                }}
              >
                S'inscrire
              </button>
            </div>
            <img src={Log} className="image" alt="" />
          </div>
          <div className="panel right-panel">
            <div className="content">
              <h4>J'ai déja un compte sur Doclic.</h4>
              <button
                className="btn2 home transparent"
                id="sign-in-btn"
                onClick={() => {
                  Sign_in_btn();
                }}
              >
                Se connecter
              </button>
            </div>
            <img src={Register} className="image" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};
export default Index;
